import { Button, makeStyles, Theme } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import clsx from 'clsx';
import HostFactory from 'commons/handler/HostFactory';
import { ExportTaskType } from 'commons/vo/param/StatisticsExportParamVO';
import React, { useEffect } from 'react';

export const API_URL = HostFactory.apiURL;

interface StatisticsDownloadButtonProps {
  taskType: ExportTaskType;
  startDate: string;
  endDate: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  downloadButton: {
    height: '40px',
    color: 'rgba(255, 255, 255, 1.0)',
    backgroundColor: 'rgba(202, 90, 150, 1.0)',
    fontWeight: 'bold',
    fontSize: '1.0em',
    borderRadius: 0,

    '&:hover': {
      backgroundColor: 'rgba(202, 90, 150, 0.9)',
    },
  },
}));

function StatisticsDownloadButton({ taskType, startDate, endDate }: StatisticsDownloadButtonProps) {
  const classes = useStyles();

  const downloadTagId = 'asset_statistics_download';

  const handleDownload = async () => {
    const downloadUrl = `${API_URL}/API/statistics/export?TASK_TYPE=${taskType}&START_DATE=${startDate}&END_DATE=${endDate}`;
    const accessToken = localStorage.getItem('accessToken');

    if (!accessToken) {
      return;
    }

    const response = await fetch(downloadUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      return;
    }

    let statisticsType = '';

    switch (taskType) {
      case ExportTaskType.Asset:
        statisticsType = '에셋';
        break;
      case ExportTaskType.Download:
        statisticsType = '다운로드';
        break;
      case ExportTaskType.Login:
        statisticsType = '로그인';
        break;
      case ExportTaskType.Partial:
        statisticsType = '부분인출';
        break;
      default:
        statisticsType = '알 수 없음';
    }

    const file = await response.blob();
    const downloadATagUrl = URL.createObjectURL(file);

    const body = document.getElementsByTagName('body')[0] as HTMLBodyElement;
    const downloadTag = `<a id='${downloadTagId}' href='${downloadATagUrl}' download='WKBL아카이브센터_${startDate}_${endDate}_${statisticsType}.xlsx'></a>`;
    body.insertAdjacentHTML('afterend', downloadTag);

    const newDownloadTag = document.getElementById(downloadTagId) as HTMLAnchorElement;
    newDownloadTag.click();
  };

  useEffect(() => {
    return () => {
      const downloadATag = document.getElementById(downloadTagId);

      if (downloadATag) {
        URL.revokeObjectURL((downloadATag as HTMLAnchorElement).href);
        downloadATag.remove();
      }
    };
  }, []);

  return (
    <Button
      className={clsx(classes.downloadButton)}
      startIcon={<GetApp fontSize="small" />}
      onClick={handleDownload}
    >
      다운로드
    </Button>
  );
}

export default StatisticsDownloadButton;
